const allowedHosts = [
  'scuccisystems.com',
  'www.scuccisystems.com',
  'dev.test.scucci.ai',
];

const isAllowedHost = () => {
  if (typeof window === 'undefined') return false;
  return allowedHosts.includes(window.location.hostname);
};

const isPlausibleReady = () =>
  typeof window !== 'undefined' && typeof window.plausible === 'function';

const getCanonicalUrl = () => {
  if (typeof window === 'undefined') return undefined;
  const { protocol, host, pathname, search, hash } = window.location;
  const normalizedPath = pathname === '/welcome' ? '/' : pathname;
  return `${protocol}//${host}${normalizedPath}${search}${hash || ''}`;
};

export const trackPageview = () => {
  if (!isAllowedHost() || !isPlausibleReady()) return;
  window.plausible('pageview', { u: getCanonicalUrl() });
};

export const trackEvent = (name) => {
  if (!name || !isAllowedHost() || !isPlausibleReady()) return;
  window.plausible(name, { u: getCanonicalUrl() });
};
